import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { TmaisFaqFormSchema } from '@/features/tmaisFaqs/schemas/form.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateTmaisFaqProps {
  id: string
  onSuccess?: () => void
  onError?: (error: ErrorResponse) => void
}

const useUpdateTmaisFaq = ({ id, onSuccess, onError }: UseUpdateTmaisFaqProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateTmaisFaq', id],
    mutationFn: async (form: TmaisFaqFormSchema) => {
      const faq = {
        question: form.question.trim(),
        answer: form.answer.trim(),
        position: Number(form.position),
      }

      return privateAxios.put(`/tmais/faqs/${id}`, { faq })
    },
    onSuccess,
    onError,
  })
}

export default useUpdateTmaisFaq
